/* src/app/bulk-transfers/bulk-transfers.component.css */
.scrollable-menu {
  height: auto;
  max-height: 200px;
  overflow-x: hidden;
}
/*# sourceMappingURL=bulk-transfers.component.css.map */
